<template>
  <div class="pauli-exclusion-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>n, l, m_l, m_s | 无法处于同一量子态$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The potential wells (Shells) -->
          <g v-for="shell in [1, 2]" :key="'s'+shell" :transform="`translate(200, 120)`">
             <circle :r="shell * 50" fill="none" stroke="rgba(255,255,255,0.1)" stroke-dasharray="2,2" />
             <text :x="shell * 50" y="-5" fill="#888" font-size="8">n = {{ shell }}</text>
          </g>

          <!-- Electrons -->
          <g v-for="e in electrons" :key="e.id" :transform="`translate(${e.x}, ${e.y})`">
             <circle r="6" :fill="e.spin > 0 ? '#ff4757' : '#00d2ff'" />
             <!-- Spin arrow -->
             <path :d="e.spin > 0 ? 'M 0,4 L 0,-4 L -2,-2 M 0,-4 L 2,-2' : 'M 0,-4 L 0,4 L -2,2 M 0,4 L 2,2'" 
                   stroke="#fff" stroke-width="1" fill="none" />
          </g>

          <text x="20" y="30" fill="#888" font-size="8">原子壳层模型</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>电子总数: {{ count }}</label>
              <div class="value" style="color: #ffd700">状态: 符合费米子统计</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>填充电子</label>
             <el-slider v-model="count" :min="1" :max="10" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>保里不相容原理指出：在同一个原子中，不可能有两个电子具有完全相同的四个量子数。具体来说，每个轨道（n, l, m_l）只能容纳两个自旋相反（m_s = +1/2 和 -1/2）的电子。这一原理决定了原子壳层的排布结构，解释了化学元素的周期性，并防止了固体物质因引力或静电力而塌缩成一个点。它是支持宏观物质体积和硬度的量子力学基础。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PauliExclusionViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      count: 2,
      electrons: [],
      timer: null
    }
  },
  watch: {
    count: {
       handler: 'updateElectrons',
       immediate: true
    }
  },
  methods: {
    updateElectrons() {
       let list = [];
       for (let i = 0; i < this.count; i++) {
          let shell = i < 2 ? 1 : 2; // n=1 for first 2, n=2 for next 8
          let angle = (i % 2 === 0) ? (i * 45) : (i * 45 + 180);
          let dist = shell * 50;
          let rad = (angle * Math.PI) / 180;
          list.push({
             id: i,
             x: 200 + Math.cos(rad) * dist,
             y: 120 + Math.sin(rad) * dist,
             spin: (i % 2 === 0) ? 1 : -1, // +1/2 and -1/2 pairs
             angle: angle
          });
       }
       this.electrons = list;
    },
    animate() {
       this.electrons.forEach(e => {
          e.angle += 1 / (e.id < 2 ? 1 : 2); // Inner shell moves faster
          let rad = (e.angle * Math.PI) / 180;
          let dist = (e.id < 2 ? 1 : 2) * 50;
          e.x = 200 + Math.cos(rad) * dist;
          e.y = 120 + Math.sin(rad) * dist;
       });
       this.timer = requestAnimationFrame(this.animate);
    }
  },
  mounted() { this.animate(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.pauli-exclusion-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 71, 87, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
